(function (angular) {
    'use strict';

    angular.module('app')
        .service('MessageUsersApi', messageUsersApi);

    messageUsersApi.$inject = [
        '$resource',
        '$rootScope',
        'settings',
    ];

    function messageUsersApi(
        $resource,
        $rootScope,
        settings,
    ) {
        /**
         * Adds any additional parameters to the resource
         * @return {this}
         */
        function transform() {
            const _this = this;

            // get the other user in this conversation
            if (this.users) {
                angular.forEach(this.users, function (user) {
                    if (parseInt(user.id, 10) !== $rootScope.thisUser.id) {
                        _this.user = user;
                    }
                });
            } else {
                this.user = {};
            }

            return this;
        }

        const resource = $resource(settings.apiBase + '/message-users/:id', {
            id: '@id',
        }, {
            get: {
                method: 'GET',
                params: {},
                responseType: 'json',
                transformResponse: function (response) {
                    if (typeof response === 'string') {
                        response = JSON.parse(response);
                    }

                    if (Array.isArray(response.data)) {
                        angular.forEach(response.data, function (user) {
                            transform.call(user);
                        });
                    } else {
                        if (response.data) {
                            transform.call(response.data);
                        }
                    }
                    if (Array.isArray(response.groupMessages)) {
                        const newGroupMessages = [];
                        if (response.groupMessages.length > 0) {
                            angular.forEach(response.groupMessages, function (groupMessage) {
                                let fullName = '';
                                groupMessage.message_thread.users.forEach(function (user) {
                                    fullName = fullName + user.cleanuser.full_name + ' / ';
                                    if (user.cleanuser.id === $rootScope.thisUser.id) {
                                        // eslint-disable-next-line no-param-reassign
                                        groupMessage.read_at = user.read_at;
                                    }
                                });
                                // eslint-disable-next-line no-param-reassign
                                groupMessage.initials = "GM";

                                // eslint-disable-next-line no-param-reassign
                                groupMessage.fullName =  fullName.slice(0, -2);

                                newGroupMessages.push(groupMessage);
                            });
                        }
                        // eslint-disable-next-line no-param-reassign
                        response.groupMessages = newGroupMessages;

                    }

                    return response;

                },
            },
        });
        resource.prototype.transform = transform;

        return resource;
    }
}(angular));
